import React from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../context/AdminAuthContext";

const ProtectedRoute = ({ children }) => {

  const {
    isAuthenticated,
    loadingAuth
  } = useAuth();


  console.log({
    isAuthenticated,
    loadingAuth
  });


  if (loadingAuth) {
    return <div>Loading...</div>;
  }


  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }


  return children;
};


export default ProtectedRoute;